var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKwhIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.952 17H1.26V3.752H2.952V12.338L6.858 8.198H8.982L5.616 11.708L8.964 17H7.02L4.446 12.932L2.952 14.498V17ZM13.1224 17L9.25242 3.986H11.0884L13.4644 11.942C13.6444 12.626 13.8244 13.31 14.0044 14.3C14.2204 13.256 14.4184 12.626 14.6164 11.942L17.0824 3.986H18.9904L21.4384 11.942C21.6544 12.644 21.8344 13.328 22.0324 14.3C22.2484 13.202 22.4284 12.536 22.6084 11.96L25.0024 3.986H26.8024L22.8784 17H21.1864L18.0364 6.704L14.8504 17H13.1224ZM29.9863 16.982H28.2943V3.752H29.9863V9.548C30.5443 8.594 31.6063 7.946 32.9743 7.946C35.2243 7.946 36.3043 9.368 36.3043 11.618V17H34.6123V11.996C34.6123 10.214 33.7663 9.494 32.5063 9.494C30.8683 9.494 29.9863 10.682 29.9863 12.194V16.982Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwhIcon);
export default __webpack_public_path__ + "static/media/kwhIcon.614714d88b184740dad80c9c9e1fe554.svg";
export { ForwardRef as ReactComponent };